import { ARTICLE_CONTENT_SETTING } from './article-content';
import { ARTICLE_DATE_SETTING } from './article-date';
import { ARTICLE_EXCERPT_SETTING } from './article-excerpt';
import { ARTICLE_TITLE_SETTING } from './article-title';

export const SETTING_ARTICLES = {
  'a-title': ARTICLE_TITLE_SETTING,
  'a-content': ARTICLE_CONTENT_SETTING,
  'a-excerpt': ARTICLE_EXCERPT_SETTING,
  'a-date': ARTICLE_DATE_SETTING,
};
